<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_custFileDesc') || '文件类型（可多选）'"
            prop="custFileDescCodes"
          >
            <dict-select
              v-model="formData.custFileDescCodes"
              url="/master/common/dict/biz"
              :body="{ dictType: 'custFileDescType' }"
              :placeholder="
                $l('form_placeholder_custFileDesc') ||
                  '请选择文件类型（可多选）'
              "
              :selectedLabel.sync="formData.custFileDesc"
              selectedLabelSeparator="、"
              filterable
              clearable
              multiple
              size="mini"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="
              $l('form_label_changeStatusDesc') ||
                '文件相关说明（内容会以邮件方式通知相关人员）'
            "
            prop="changeStatusDesc"
          >
            <el-input
              v-model="formData.changeStatusDesc"
              :placeholder="
                $l('form_placeholder_changeStatusDesc') ||
                  '请输入文件相关说明（内容会以邮件方式通知相关人员）'
              "
              type="textarea"
              maxlength="200"
              :rows="4"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" class="mt-3">
          <el-form-item prop="listDoc">
            <el-upload
              drag
              action="#"
              multiple
              :file-list="formData.listDoc"
              :auto-upload="false"
              :on-change="onFileChange"
              :on-remove="onFileChange"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
                }}<em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    custFolderCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { listDoc: [] },
      rules: {
        custFileDescCodes: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custFileDesc') ||
              '请选择文件类型（可多选）',
            trigger: 'change',
          },
        ],
        changeStatusDesc: [
          {
            required: true,
            message:
              this.$l('form_placeholder_changeStatusDesc') ||
              '请输入文件相关说明（内容会以邮件方式通知相关人员）',
            trigger: 'blur',
          },
        ],
        listDoc: [
          {
            required: true,
            message: this.$l('form_placeholder_listDoc') || '请选择相关文档',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    onFileChange(files, fileList) {
      this.formData.listDoc = fileList
    },
    async upload() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return

      const listDoc = await this.uploadFiles(this.formData.listDoc)
      if (listDoc.includes(null)) {
        this.loadingClose()
        this.$message.error(this.$l('tips_error_uploadDoc') || '文档上传失败！')
        return
      }

      const res = await this.$api
        .masterCustomerDocUploadApi({
          ...this.formData,
          custCode: this.custCode,
          custFolderCode: this.custFolderCode,
          listDoc: listDoc.map((item) => ({
            ...item,
            custFileDescCodes: this.formData.custFileDescCodes,
            custFileDesc: this.formData.custFileDesc,
            changeStatusDesc: this.formData.changeStatusDesc,
          })),
          sendEmail: true,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.$emit('reload')
      this.close()
    },
    async uploadFiles(listDoc) {
      if (!listDoc?.length) return Promise.resolve([])

      const uploadTask = listDoc.map((file) => {
        return new Promise((resolve) => {
          this.push({
            file: file.raw,
            added: ({ md5, suffix }) => {
              const fileCode = [md5, suffix].filter(Boolean).join('.')
              resolve({
                custFileCode: fileCode,
                custFileName: file.name,
                custFileSize: this.formatFileSize(file.size),
              })
            },
            fail: () => resolve(null),
          })
        })
      })
      return await Promise.all(uploadTask)
    },
    formatFileSize(bytes) {
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + 'MB'
      } else if (bytes >= 1024) {
        return (bytes / 1024).toFixed(2) + 'KB'
      } else {
        return bytes + 'B'
      }
    },
    cancel() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => this.upload())
        .catch((action) => {
          if (action === 'cancel') this.close()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-upload,
  .el-upload-dragger {
    width: 100%;
  }
}
</style>
